import React, {useContext} from 'react'
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../../pages/ProductStencil";
import * as querystring from "querystring";

export const Applications = () => {
    const translate = useI18N();
    const {product} = useContext(ProductContext);
    const {applications} = product.tags;
    const isNoData = !applications.length;

    return (
        <div className={`${isNoData ? 'accordion__applications no-data' : 'accordion__applications'}`}>
            {applications.map(({title, url, path}, index) => (
                <a href={`${url}?tag=${encodeURIComponent(path)}`} key={index}>
                    {translate(title)}{index < applications.length - 1 ? ',' : ''}
                </a>
            ))}
        </div>
    )
}
